<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>重新分派权限配置</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入名称/编号/备注"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">
          新建
        </el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'in:state|array-integer#and': '0,1',
                'regex:name|string#or': searchValue,
                'regex:code|string#or': searchValue,
                'regex:memo|string#or': searchValue,
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'reassignPermission',
                title: '重新分派权限配置'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
          :row-class-name="osg.lastRowClassName"
        >
          <c-table :fields="extFields"></c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-else-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row)">
                    归档
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="重新分派权限配置"
      :visible.sync="openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
        labelWidth="110px"
      >
        <template slot="conditions">
          <el-form-item>
            <el-tag type="success" size="medium">多条件均满足时生效</el-tag>
          </el-form-item>
          <el-form-item v-for="(condition, index) of formData.conditions" :key="index">
            <div>条件{{ index + 1 }}</div>
            <div class="condition-card">
              <el-card shadow="hover">
                <el-form-item label="匹配条件">
                  <el-select
                    v-model="formData.conditions[index].type"
                    placeholder="请选择"
                    @change="
                      formData.conditions[index].value = [];
                      getOptions(formData.conditions[index].type);
                    "
                    clearable
                  >
                    <el-option
                      v-for="item in options.reassignPermissionType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="
                        formData.conditions.some(
                          K =>
                            K.type == item.value ||
                            (item.value.endsWith('Inverse')
                              ? item.value.substring(0, item.value.length - 7) == K.type
                              : item.value + 'Inverse' == K.type)
                        )
                      "
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!-- 按服务商 -->
                <!-- <el-form-item
                  v-if="formData.conditions[index].type == 'orgId'"
                  :label="
                    '按' + osg.codelabel('reassignPermissionType', formData.conditions[index].type)
                  "
                >
                  <el-cascader
                    v-model="formData.conditions[index].value"
                    :options="options.orgs"
                    :props="{
                      expandTrigger: 'hover',
                      multiple: true,
                      checkStrictly: true,
                      label: 'orgName',
                      value: '_id',
                      children: 'orgList',
                      emitPath: false
                    }"
                    clearable
                  ></el-cascader>
                </el-form-item> -->
                <el-form-item
                  v-if="formData.conditions[index].type.startsWith('partnerIds')"
                  :label="
                    '按' + osg.codelabel('reassignPermissionType', formData.conditions[index].type)
                  "
                >
                  <el-select
                    v-model="formData.conditions[index].value"
                    multiple
                    filterable
                    clearable
                    placeholder="可搜索服务商名称"
                  >
                    <el-option
                      v-for="item in options.partners"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <!--按信息渠道-->
                <el-form-item
                  v-else-if="formData.conditions[index].type.startsWith('channel')"
                  :label="
                    '按' + osg.codelabel('reassignPermissionType', formData.conditions[index].type)
                  "
                >
                  <el-cascader
                    v-model="formData.conditions[index].value"
                    :options="options.channel"
                    :props="{ multiple: true, checkStrictly: true, label: 'name', emitPath: false }"
                    clearable
                  ></el-cascader>
                </el-form-item>
                <!--按其他 档案字段-->
                <el-form-item
                  v-else
                  :label="
                    '按' + osg.codelabel('reassignPermissionType', formData.conditions[index].type)
                  "
                >
                  <el-select
                    v-model="formData.conditions[index].value"
                    multiple
                    clearable
                    filterable
                    allow-create
                    @change="
                      conditionValueChange(
                        formData.conditions[index].type,
                        formData.conditions[index].value
                      )
                    "
                  >
                    <el-option
                      v-for="item in options[formData.conditions[index].type]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-card>
              <div class="card-remove">
                <i class="el-icon-remove" @click="removeCondition(index)"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button plain icon="el-icon-plus" class="button_dashed" @click="newCondition">
              新增条件
            </el-button>
          </el-form-item>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  data() {
    window.$this = this;
    return {
      tenantId: '',
      name: 'reassignPermission',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: { conditions: [{ type: '', value: [] }], exts: {} },
      extFields: [],
      extField: {},
      rules: this.$util.rules,
      options: {
        codecfg_reassignPermissionType: { codeId: 'reassignPermissionType' },
        partners: [],
        orgs: []
      },
      area: {
        options: this.osg.areaList
      }
    };
  },
  async mounted() {
    this.doInit();
    this.osg.getFields('reassignPermission', () => {
      this.osg.getFpi();
      this.getData();
      this.getPartners();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { conditions: [{ type: '', value: [] }], exts: {} };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        'regex:name|string#or': this.searchValue,
        'regex:code|string#or': this.searchValue,
        'regex:memo|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/reassignPermission/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      for (let condition of row.conditions) {
        this.getOptions(condition.type);
      }
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveExtField(this.extFields, this.formData);
        this.osg.ajax(
          'biz/reassignPermission/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    doEnable(id) {
      this.osg.ajax('biz/reassignPermission/enable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('biz/reassignPermission/disable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除${row.name}？`, () => {
        this.osg.ajax('biz/reassignPermission/delete.do', { id: row._id }, () => {
          this.getData();
          this.osg.toast('操作成功');
        });
      });
    },
    //新增条件
    newCondition() {
      this.formData.conditions.push({
        type: '',
        value: []
      });
    },
    //删除条件
    removeCondition(index) {
      this.formData.conditions.splice(index, 1);
    },
    //获取字典表
    getOptions(type) {
      let newType = type;
      if (type.endsWith('Inverse')) {
        type = type.substring(0, type.length - 7);
      }
      if (type != 'partnerIds') {
        this.options['codecfg_' + newType] = {
          codeId: type.indexOf('exts.') != -1 ? type.split('.')[1] : type
        };
        this.osg.codeoption(() => {
          this.$forceUpdate();
        });
      }
    },
    getPartners() {
      this.osg.ajax(
        'basic/partner/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.partners = res.data;
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    getOrgs() {
      this.osg.ajax(
        'org/query.do',
        {
          _all: 1,
          'is:state|integer#and': 1,
          notFilterOrgId: '1',
          notFilterBelongTo: '1'
        },
        res => {
          this.options.orgs = res.data.orgList;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    }
  }
};
</script>
